module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-selectize"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "id": _vm._uid + '-selectize'
    }
  }), (_vm.showAdd) ? _c('div', {
    staticClass: "input-group-button"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.$emit('toggleAdd')
      }
    }
  }, [_c('div', {
    staticClass: "fa fa-plus"
  })])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-129304c7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/Selectize.vue
// module id = 2268
// module chunks = 1